module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrapper-md"
  }, [(_vm.comitentes) ? _c('div', {
    staticClass: "row wrapper-md"
  }, [_vm._v("\n      Permitir voltar lote:"), _c('br'), _c('br'), _vm._v(" "), _vm._l((_vm.comitentes), function(comitente) {
    return _c('span', {
      key: 'comitente-' + comitente.id,
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('label', {
      staticClass: "i-switch bg-success m-t-xs m-r"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (comitente.permitirVoltaLote),
        expression: "comitente.permitirVoltaLote"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(comitente.permitirVoltaLote) ? _vm._i(comitente.permitirVoltaLote, null) > -1 : (comitente.permitirVoltaLote)
      },
      on: {
        "change": [function($event) {
          var $$a = comitente.permitirVoltaLote,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(comitente, "permitirVoltaLote", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(comitente, "permitirVoltaLote", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(comitente, "permitirVoltaLote", $$c)
          }
        }, function($event) {
          return _vm.alteraPermissao(comitente)
        }]
      }
    }), _vm._v(" "), _c('i')]), _vm._v(" " + _vm._s(comitente.nome) + "\n      ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.pendenciasFiltradas), function(p) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-6 hover-items"
    }, [_c('div', {
      staticClass: "panel wrapper"
    }, [_c('h1', {
      staticClass: "m-t-none"
    }, [_vm._v("Lote " + _vm._s(p.lote.numero))]), _vm._v(" "), _c('h4', {
      staticClass: "m-t-none"
    }, [_vm._v(_vm._s(p.arrematante.apelido))]), _vm._v(" "), _c('h4', {
      staticClass: "m-t-none"
    }, [_vm._v(_vm._s(p.arrematante.pessoa.nome))]), _vm._v(" "), (!p.aceito) ? _c('a', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          return _vm.aceitar(p.id, p)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check m-r-xs"
    }), _vm._v(" Aceitar")]) : _c('div', {
      staticClass: "font-bold btn btn-black"
    }, [_vm._v("Aceito")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.visualizar(p)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye m-r-xs"
    }), _vm._v(" Ocultar")])])])
  }), 0), _vm._v(" "), (!_vm.pendencias || _vm.pendenciasFiltradas.length === 0) ? _c('div', [_vm._v("\n      Nenhuma interação até o momento\n    ")]) : _vm._e(), _vm._v(" "), (_vm.pendencias && _vm.pendencias.length > 0 && _vm.pendencias.length !== _vm.pendenciasFiltradas.length) ? _c('div', {
    staticClass: "m-t"
  }, [_c('div', {
    staticClass: "m-b-xs"
  }, [_vm._v("Você ocultou algumas pendencias por tê-las visualizado.")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.pendenciasVisualizadas = []
      }
    }
  }, [_vm._v("Reativar pendencias ocultadas")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a3b32fe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/MonitorVoltarLote.vue
// module id = 798
// module chunks = 2